import { Doughnut } from "react-chartjs-2";
import { Chart, ArcElement, Tooltip, Legend } from "chart.js";

Chart.register(ArcElement, Tooltip, Legend);

const segmentLabels = [
  "Presale", "Liquidity", "Burning", "Ecosystem", 
  "Marketing", "IHKAAS Mall", "Team", "Charity"
];

const baseColors = [
  "#3DF19D", "#3377FF", "#FF4500", "#B41EFB", 
  "#FA30C0", "#31A6EC", "#5E29F5", "#228B22"
];

const hoverColors = [
  "#3DF19D", "#3377FF", "#FF4500", "#B41EFB", 
  "#FA30C0", "#31A6EC", "#5E29F5", "#228B22"
];

export default function CustomPieChart({ activeCard }) {
  const pieData = {
    labels: segmentLabels,
    datasets: [
      {
        data: [30, 25, 17, 6, 7, 8, 4, 3], // Ensure this matches segmentLabels order
        backgroundColor: baseColors.map((color, index) =>
          index === (activeCard - 1) ? hoverColors[index] || color : color
        ),
        borderColor: baseColors.map((_, index) =>
          index === (activeCard - 1) ? "rgb(226, 220, 128)" : "#111"
        ),
        borderWidth: baseColors.map((_, index) =>
          index === (activeCard - 1) ? 6 : 4
        ),
        hoverOffset: baseColors.map((_, index) =>
          index === (activeCard - 1) ? 10 : 0
        ),
        cutout: "60%", // Inner hollow effect
      },
    ],
  };

  return (
    <div className="flex justify-center items-center bg-black p-12 rounded-lg">
      <div className="w-80 h-80 relative">
        <Doughnut data={pieData} options={{ responsive: true, maintainAspectRatio: false }} />
      </div>
    </div>
  );
}
